module.exports = __webpack_public_path__ + "1791188489487/images/brandbook-half-o-side.46617fe.svg";